"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'conversation.end.failed': '对话结束失败',
};
